module.exports = __webpack_public_path__ + "static/media/competitive-icon.4ec4c512.svg";